import React, { FunctionComponent } from 'react';

import { ContextProps } from 'reviews2/feed/review-yeti/Review.types';

import 'reviews2/feed/review-yeti/location/ReviewLocation.scss';

export const ReviewLocation: FunctionComponent<ContextProps> = ({ context }) => {
    const { review } = context;
    const { showLocation } = context.options!;

    if (!review || !showLocation) {
        return null;
    }

    return <div className="r4e-review-location">{review.location?.internalName}</div>;
};
